import React, { Component, lazy } from 'react';
import classNames from 'classnames';
import { addTranslation, IntlProps } from 'decorators/addTranslation';

import { Tab, TabsContainer as Tabs } from 'components/ui/tabs';

import FormFields from './FormFields';
import SubmittedForm from './components/submittedForm';
const ResultMessageWl19 = lazy(() => import("../resultMessage/ResultMessage.wl19"));

import FormFieldsProps from './FormFieldsProps';
import './formFields.scss';
import { WL_ID_19 } from 'constants/wlIds';

interface Props extends FormFieldsProps, IntlProps {
  title?: string;
  subText?: string
  loadMore?: (name: string) => void;
  wlId?: number | null;
}

class FormView extends Component<Props> {
  renderTabs = () => {
    const { tabs, getTranslate, onChangeTab, onBeforeChange } = this.props;

    if (!tabs) {
      return null;
    }

    return (
      <Tabs
        theme='brand'
        needUpdateDefaultTab
        defaultActiveTabIndex={tabs.findIndex((tab) => tab.isCurrent)}
        customClass='ui-form-fields__tabs ui-tabs_form-fields'
        onClick={onChangeTab}
        onBeforeChange={onBeforeChange}>
        {tabs.map((tab) => {
          return (
            <Tab key={tab.id} id={tab.id} title={getTranslate(tab.label)}>
              {this.renderFields()}
            </Tab>
          );
        })}
      </Tabs>
    );
  };

  renderFields = () => {
    const { formFields, filtersValues, fieldsConfig, filtersValuesCustom } =
      this.props;

    return formFields ? (
      React.cloneElement(formFields, {
        filtersValues: filtersValues,
        fieldsConfig: fieldsConfig,
      })
    ) : (
      <FormFields
        {...this.props}
        dictionaries={{
          ...filtersValues,
          ...filtersValuesCustom,
        }}
      />
    );
  };

  renderResult = () => {
    const {
      id,
      submittedTitle,
      submittedText,
      repeatCreateButtonText,
      onReset,
      status,
      repeatBackText,
      backText,
      repeatBackUrl,
      backUrl,
      link,
      wlId
    } = this.props;
    const sharedProps = {
      id,
      title: submittedTitle,
      text: submittedText,
      primaryButtonText: repeatCreateButtonText,
      onPrimaryButtonClick: onReset,
      status,
      secondaryButtonText: repeatBackText || backText,
      onSecondaryButtonLink: repeatBackUrl || backUrl,
      link,
    };
    if (wlId === WL_ID_19) {
      return <ResultMessageWl19 {...sharedProps} />;
    }

    return <SubmittedForm {...sharedProps} />;
  };

  render() {
    const { id, getTranslate } = this.props;

    return (
      <div
        className={classNames('ui-form-fields', `ui-form-fields_${id}`, {
          [`${this.props.customClass}`]: !!this.props.customClass,
        })}>
        {this.props.isSubmitted ? (
          this.renderResult()
        ) : (
          <>
            {this.props.title ? (
                <div className='ui-form-fields__container ui-form-fields__container_header'>
                  <div className='ui-form-fields__title'>
                    {getTranslate(this.props.title)}
                  </div>
                  {this.props.subText && (
                    <div className='ui-form-fields__subtext mt-4 text-l-regular'>
                      {this.props.subText}
                    </div>
                  )}
                </div>
            ) : null}
            {this.props.tabs ? this.renderTabs() : this.renderFields()}
          </>
        )}
      </div>
    );
  }
}

export default addTranslation(FormView);
